
import { useEffect, useState } from 'react';


export default function EventMasterPopUp({ handelClosePopUpClick,popupflag }) {

    const [productCategoryName, setproductCategoryName] = useState("")

    return (
        <>
            <div className="modal fade show" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLongTitle">Event Master</h5>
                            <button onClick={() => handelClosePopUpClick()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">


                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Event Name<span className='text-danger'></span></label>
                                        <input
                                            // value={productCategoryName}
                                            // onChange={(e) => setproductCategoryName(e.target.value)}
                                            type="text"
                                            className="form-control"
                                            name="DepartmentName"
                                            placeholder="Department Name" />

                                    </div>
                                </div>

                                


                                <div className="col-12">
                                    <div className="form-group float-right">

                                        <button
                                            // disabled={productCategoryName === ""}
                                            type='button'
                                            // onClick={handelSubmit}
                                            className="btn btn-add btn-md" data-ktwizard-type="action-next">
                                           {popupflag}
                                        </button>
                                        <button
                                            type='button'
                                            // onClick={() => handelClosePopUpClick()}
                                            className="btn clear-btn btn-md" data-ktwizard-type="action-next">
                                            CLEAR
                                        </button>
                                    </div>
                                </div>

                            </div>




                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}